/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_TitleInputs */



/**
* | output |
* | --- |
* | "Iconik Publish" |
*
* @param {Iconik_Publish_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_title = /** @type {((inputs?: Iconik_Publish_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publication Iconik")
	if (locale === "de") return /** @type {LocalizedString} */ ("Iconik Publish")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iconik Publish")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Iconik Publish")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iconik Publish")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Iconik出版社")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Iconik Publish")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आइकॉनिक पब्लिश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iconik Publica")
	return /** @type {LocalizedString} */ ("Iconik Publish")
});